import { ActionType } from "../../../UI.Controls/Actions/IAction";
import { ILogicalComponent } from "../../LogicalTree/ILogicalComponent";
import { RightsEvaluationOverrides } from "../../Rights/RightsEvaluationOverrides";
import { StandardAction } from "./Actions/StandardAction";
import { IFrameWithRights } from "./IFrame";
import { MSLOV } from "./MSLOV";

interface IMSLOVRightEvaluationOverrideFunctions {
    /** Určuje viditelnost akce "Zobrazit vše" (i neodpovídající filtru) */
    showAllItemsActionVisible: () => boolean;
    /** Určuje viditelnost akce "Skrýt záznamy neodpovídající filtru" */
    showOnlyFilterItemsActionVisible: () => boolean;
}

export class MSLOVRightEvaluationOverrides extends RightsEvaluationOverrides {
    private readonly _functions: IMSLOVRightEvaluationOverrideFunctions;

    protected override get _frame(): MSLOV {
        return this.__frame as MSLOV;
    }

    constructor(frame: IFrameWithRights, functions: IMSLOVRightEvaluationOverrideFunctions) {
        super(frame);
        this._functions = functions;
    }

    protected override async _standardActionsVisible(controlWrapper: ILogicalComponent): Promise<boolean | null> {
        const superResult = super._standardActionsVisible(controlWrapper);

        const standardAction = controlWrapper.control as StandardAction;

        switch (standardAction.actionType) {
            case ActionType.standardSelectAll:
            case ActionType.standardDeselectAll:
            case ActionType.standardDeleteRecords:
                return true;
            case ActionType.standardShowAll:
                return this._functions.showAllItemsActionVisible();
            case ActionType.standardShowFiltered:
                return this._functions.showOnlyFilterItemsActionVisible();
        }

        return await superResult;
    }

    protected override async _standardActionsEnabled(controlWrapper: ILogicalComponent): Promise<boolean | null> {
        const superResult = super._standardActionsVisible(controlWrapper);

        const standardAction = controlWrapper.control as StandardAction;

        switch (standardAction.actionType) {
            case ActionType.standardSelectAll:
            case ActionType.standardDeselectAll:
            case ActionType.standardDeleteRecords:
                return this._frame.isActive && !this._frame.isEmpty;
            case ActionType.standardShowAll:
            case ActionType.standardShowFiltered:
                return true; // nemění výběr
        }

        return superResult;
    }

    protected override _enabledVisualControlsEnabledVisual(controlWrapper: ILogicalComponent): boolean | null {
        const superResult = super._enabledVisualControlsEnabledVisual(controlWrapper);
        const standardAction = controlWrapper.control as StandardAction;
        if (standardAction.actionType) {
            switch (standardAction.actionType) {
                //Je potřeba override i pro enabledVisual. Tyto 2 akce předpoklají že jsou obě enabled a jen přepínají mezi sebou svou viditelnost metodou v MSLOV (bez nutnosti vyhodnocení práv).
                //Jelikož vyhodnocení práv se nevolá vždy když mezi sebou přepínají, jedna z těchto akcí je vždy !visible a tedy !enabledVisual.
                //Při přepnutí viditelnosti v MSLOV je pak akce sice visible ale !enabledVisual - protože ji tak dříve vyhodnotily práva.
                //Override způsobí, že při vyhodnocení práv jsou obě akce enabledVisual a jen přepínají viditelnost. Šlo by
                //by volat vyhodnocení práv, ale v tomhle případě se jedná o akce, která nemají serverová práva a je zbytečné znovu vyhodnocovat práva.
                case ActionType.standardShowAll:
                case ActionType.standardShowFiltered:
                    return true;
            }
        }
        return superResult;
    }
}
